import React, { useState } from 'react';
import tw from 'twin.macro';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import MapComponent from './MapComponent';

const DireccionesModal = ({ userId, mostrarModalDirecciones, setMostrarModalDirecciones, onGuardarDireccion }) => {
	const [direccionSeleccionada, setDireccionSeleccionada] = useState(null);
	const [direccionDentroZona, setDireccionDentroZona] = useState(true);
	const [titulo, setTitulo] = useState('');
	const [predeterminado, setPredeterminado] = useState(false);
	const [opcional, setOpcional] = useState('');
	const Titulo = tw.h2`text-lg font-bold`;
	const MENSAJE_FUERA_ZONA = 'No hacemos envíos a esa zona. Podés retirar tu pedido en nuestros pick-ups.';
	const TOAST_FUERA_ZONA_OPTIONS = {
		autoClose: 5000,
	};

	const handleDireccionSeleccionada = ({ direccion, coordenadas, estaEnZonaEnvio = true }) => {
		if (estaEnZonaEnvio) {
			setDireccionSeleccionada({ direccion, coordenadas });
			setDireccionDentroZona(true);
			return;
		}

		setDireccionSeleccionada(null);
		setDireccionDentroZona(false);
	};

	const handleConfirmar = async () => {
		if (!direccionDentroZona) {
			toast.error(MENSAJE_FUERA_ZONA, TOAST_FUERA_ZONA_OPTIONS);
			return;
		}

		if (direccionSeleccionada && titulo.trim()) {
			const aclaracion = opcional.trim();
			const nuevaDireccion = {
				cliente_id: userId, // Esto deberías tomarlo de tu contexto o estado global
				titulo,
				predeterminado,
				latitud: direccionSeleccionada.coordenadas.lat,
				longitud: direccionSeleccionada.coordenadas.lng,
				direccion: direccionSeleccionada.direccion + (aclaracion ? ` (${aclaracion})` : ''),
			};

			console.log('Dirección a guardar:', nuevaDireccion);

			try {
				// Llama a la función para enviar los datos al backend
				const guardada = await onGuardarDireccion(nuevaDireccion);
				if (!guardada) {
					return;
				}
			} catch (error) {
				toast.error(error.message || 'No se pudo guardar la dirección.');
				return;
			}

			// Cierra el modal
			setMostrarModalDirecciones(false);

			// Limpia los campos
			setTitulo('');
			setPredeterminado(false);
			setDireccionSeleccionada(null);
			setDireccionDentroZona(true);
			setOpcional('');
		} else {
			toast.error('Por favor, completá todos los campos e indicá una dirección válida.');
		}
	};

	return (
		<div>
			<Modal
				isOpen={mostrarModalDirecciones}
				onRequestClose={() => setMostrarModalDirecciones(false)}
				contentLabel="Tus Direcciones"
				style={{
					content: {
						top: '50%',
						left: '50%',
						right: 'auto',
						bottom: 'auto',
						marginRight: '-50%',
						transform: 'translate(-50%, -50%)',
						width: '95%',
						maxWidth: '800px',
						maxHeight: '90vh',
						overflowY: 'auto',
						WebkitOverflowScrolling: 'touch',
						padding: '20px',
						borderRadius: '10px',
					},
					overlay: { backgroundColor: 'rgba(0, 0, 0, 0.75)', zIndex: '1000' },
				}}
			>
				<Titulo>Agregar Dirección</Titulo>

				<div style={{ marginBottom: '10px' }}>
					<label>
						Nombre de la Dirección:
						<input
							type="text"
							value={titulo}
							onChange={(e) => setTitulo(e.target.value)}
							placeholder="Ejemplo: Casa, Trabajo"
							style={{
								width: '100%',
								padding: '10px',
								marginTop: '5px',
								border: '1px solid #ccc',
								borderRadius: '5px',
							}}
						/>
					</label>
				</div>

				<div style={{ marginBottom: '10px' }}>
					<label>
						<input
							type="checkbox"
							checked={predeterminado}
							onChange={(e) => setPredeterminado(e.target.checked)}
							style={{ marginRight: '10px' }}
						/>
						Marcar como predeterminada
					</label>
				</div>
				<MapComponent
					onDireccionSeleccionada={handleDireccionSeleccionada}
					setOpcional={setOpcional}
					isInModal
				/>
				<button
					onClick={handleConfirmar}
					disabled={!direccionSeleccionada || !titulo.trim() || !direccionDentroZona}
					style={{
						marginTop: '20px',
						padding: '10px 20px',
						fontSize: '14px',
						backgroundColor:
							!direccionSeleccionada || !titulo.trim() || !direccionDentroZona ? '#d1d5db' : '#99cdb6',
						color: '#fff',
						border: 'none',
						borderRadius: '5px',
						cursor:
							!direccionSeleccionada || !titulo.trim() || !direccionDentroZona ?
								'not-allowed'
							:	'pointer',
					}}
				>
					Confirmar
				</button>
			</Modal>
		</div>
	);
};

export default DireccionesModal;
